<div class="ana">
    <img ngSrc="./simgeler/logo.webp"
         alt="Site Logo"
         width="32"
         height="32"
         (click)="solSimgeTiklandi.emit()"
         class="buyut hover:buyut-1 active:buyut-1"
         style="height: 32px; width: 32px;box-shadow: none !important;">

    <img ngSrc="./simgeler/fikoyt_yazi.webp"
         alt="Site Logo Yazı"
         height="24"
         width="72"
         priority
         (click)="logoTiklandi.emit()"
         class="buyut hover:buyut-1 active:buyut-1"
         style="height: 24px; width: unset; box-shadow: none !important;">

    @if (yolGoster()) {
    <nz-breadcrumb [@fade]="yolGoster()"
                   [nzAutoGenerate]="true"
                   nzSeparator="➜"
                   nzRouteLabel="simge"
                   style="align-self: unset;margin-bottom: 0em;padding-left: 0px;"></nz-breadcrumb>
    }


    <span style="flex: 1;"></span>
    @if (baslikPortal.sagTarafTemplate()) {
        <ng-container *ngTemplateOutlet="baslikPortal.sagTarafTemplate()"></ng-container>
    }
    <ng-content select=".sag-taraf"></ng-content>
    @if (FikoYT.kimlik.aktifKullaniciJson()) {
    <img [src]="FikoYT.env.adres.fapiUrl+'/fikoyt.com.FikoYT.sistem.aktif-kullanici.profilResmi?boyut=60x?&t='+FikoYT.parametreler['t']+'&quality=40'"
         alt="Site Logo"
         width="24"
         height="24"
         style="width:24px;height:24px;"
         class="kullanici-resmi buyut hover:buyut-1 active:buyut-1"
         nz-tooltip
         nzTooltipColor="#fff"
         [nzTooltipTitle]="kullaniciMenuTemp"
         nzTooltipPlacement="bottomRight"
         nzTooltipTrigger="click"
         nzTooltipOverlayClassName="km-tooltip-overlay"
         [nzTooltipOverlayStyle]="{'max-width': '320px', 'padding': '0'}">
    } @else {
    <img src="./simgeler/users.webp"
         alt="Site Logo"
         width="24"
         height="24"
         style="width:24px;height:24px;"
         class="kullanici-resmi buyut hover:buyut-1 active:buyut-1"
         nz-tooltip
         nzTooltipColor="#fff"
         [nzTooltipTitle]="kullaniciMenuTemp"
         nzTooltipPlacement="bottomRight"
         nzTooltipTrigger="click"
         nzTooltipOverlayClassName="km-tooltip-overlay"
         [nzTooltipOverlayStyle]="{'max-width': '320px', 'padding': '0'}">
    }
</div>

<div style="position: absolute; left: 0; right: 0; text-align: center;pointer-events: none; ">
    <button class="alt-baslik buyut hover:buyut-1 active:buyut-1"
            style="pointer-events: all;"
            onclick="window.scroll({ top: 0, left: 0, behavior: 'smooth' });"
            (click)="altBaslikTiklandi.emit()">
        <!-- {{ FikoYT.parametreler['altBaslik'].ayarlar?.solSimge}} -->
        {{ altBaslik()?.ayarlar?.solSimge }}
        {{ altBaslik()?.degeri }}
    </button>
</div>

<ng-template #kullaniciMenuTemp>
    <fikoyt-diyalog-kullanici-menu></fikoyt-diyalog-kullanici-menu>
</ng-template>